import React, { useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ErrorModalComponent } from "@me-pos/error-modal";
import i18next from "i18next";

type ExportBtnPropsType = {
    companyId: number;
    exportType: string;
    classes?: string;
    branchId: string;
    exportByBranch?: number | null;
};

export const ExportBtn: React.FC<ExportBtnPropsType> = (props) => {
    const { t: translate, i18n } = useTranslation();
    const [currentStatusError, setCurrentStatusError] = useState<number>(null);
    const responseUrl = useMemo(() => {
        const base = process.env.REACT_APP_POS_URL ?? "";
        const langPrefix = i18n.language !== "en" ? `/${i18n.language}` : "";

        const params = new URLSearchParams();

        if (props.exportByBranch != null && props.exportByBranch !== -1) {
            params.set("branchId", String(props.exportByBranch));
        }

        const query = params.toString() ? `?${params.toString()}` : "";

        return `${base}${langPrefix}/ajax/export/company/${encodeURIComponent(
            String(props.companyId)
        )}/${encodeURIComponent(String(props.branchId))}/${encodeURIComponent(
            props.exportType
        )}/start-csv-generation${query}`;
    }, [props.companyId, props.branchId, props.exportType, props.exportByBranch, i18n.language]);
    const startGenerationFileHandler = async () => {
        try {
            const response = await fetch(responseUrl, {
                method: "POST",
                headers: { "Content-type": "application/json" },
                credentials: "include",
            });

            if (response.status === 401) {
                window.location.href = `${process.env.REACT_APP_POS_URL}/login`;
                return;
            }

            if (!response.ok) {
                setCurrentStatusError(response.status);
            }
        } catch {
            setCurrentStatusError(500);
        }
    };

    return (
        <>
            <Button
                variant={"outline-violet"}
                className="border-primary text-primary fw-normal d-flex justify-content-center  align-items-center w-100 mb-3 mb-xl-0"
                onClick={startGenerationFileHandler}
            >
                <i className="bi bi-box-arrow-up"></i>
                <span className={`${props.classes} ms-1`}>{translate("export")}</span>
            </Button>
            <ErrorModalComponent
                i18n={i18next}
                onClose={() => {}}
                isOpen={!!currentStatusError}
                currentError={currentStatusError}
            />
        </>
    );
};
